var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","clipped-left":"","clipped-right":"","color":_vm.navbarColor,"dark":_vm.navbarColor !== 'white'}},[_c('div',{on:{"click":_vm.showhideLogo}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.$vuetify.breakpoint.smAndDown
          ? _vm.setSidebarDrawer(!_vm.Sidebar_drawer)
          : _vm.$emit('input', !_vm.value)}}})],1),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }